import { HttpHandler } from 'msw';
import {
  automationInsightsAllNullHandlers,
  automationInsightsHandlers,
  automationInsightsNoGapsHandlers,
} from './automationAssistantHandlers';
import { eInvoicingHandlers } from './eInvoicingHandlers';
import {
  loginPageDisabledHandlers,
  loginPageDisabledNoSsoHandlers,
  loginPageSlowHandlers,
} from './loginPageDisabledHandlers';
import {
  queueAutomationConflictHandlers,
  queueAutomationEmptyHandlers,
  queueAutomationHandlers,
} from './queueAutomationHandlers';

export const handlersMap: Record<string, HttpHandler[]> = {
  automationInsights: automationInsightsHandlers,
  automationInsightsAllNull: automationInsightsAllNullHandlers,
  automationInsightsNoGaps: automationInsightsNoGapsHandlers,
  eInvoincing: eInvoicingHandlers,
  loginPageDisabled: loginPageDisabledHandlers,
  loginPageDisabledNoSso: loginPageDisabledNoSsoHandlers,
  loginPageSlow: loginPageSlowHandlers,
  queueAutomation: queueAutomationHandlers,
  queueAutomationEmpty: queueAutomationEmptyHandlers,
  queueAutomationConflict: queueAutomationConflictHandlers,
};
